// Enumerations
import { DevicesBreakpointsEnumeration } from '../../../../../enumerations/devices/devices-breakpoints.enumeration';
// Foundations
import { FontsSizesFoundationsThemes } from '../../commons/fonts-sizes-foundations.themes';
import { FontsLineHeightsFoundationsThemes } from '../../commons/fonts-line-heights-foundations.themes';
const FoundationsKubitBnplAlternativeFontsHeadingsTheming = {
    font_heading_6: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_xl,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_xl,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_xl,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_xl,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_xl,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_xl,
        },
    },
    font_heading_8: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_xl,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_xl,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_xl,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_xl,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_xl,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_xl,
        },
    },
    font_heading_13: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_1,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_1,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_1,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_1,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_1,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_1,
        },
    },
    font_heading_25: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_1,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_1,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_1,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_1,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_1,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_1,
        },
    },
    font_heading_50: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_2,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_2,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_2,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_2,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_2,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_2,
        },
    },
    font_heading_100: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_2,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_2,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_2,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_2,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_display_2,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_display_2,
        },
    },
    font_heading_250: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_h1,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_h1,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_h1,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_h1,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_h1,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_h1,
        },
    },
    font_heading_300: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_h1,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_h1,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_h1,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_h1,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_h1,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_h1,
        },
    },
    font_heading_400: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_h2,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_h2,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_h2,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_h2,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_h2,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_h2,
        },
    },
    font_heading_450: {
        [DevicesBreakpointsEnumeration.DESKTOP]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_h2,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_h2,
        },
        [DevicesBreakpointsEnumeration.TABLET]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_h2,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_h2,
        },
        [DevicesBreakpointsEnumeration.MOBILE]: {
            font_size: FontsSizesFoundationsThemes.font_size_heading_xllm_h2,
            line_height: FontsLineHeightsFoundationsThemes.font_line_height_heading_xllm_h2,
        },
    },
};
export { FoundationsKubitBnplAlternativeFontsHeadingsTheming };
//# sourceMappingURL=foundations-kubit-bnpl-alternative-fonts-headings.theming.js.map